import {produce} from "immer";

const PaxNotifierDrawerActionTypes = {
    OPEN_DRAWER: 'OPEN_DRAWER',
    CLOSE_DRAWER: 'CLOSE_DRAWER',
} as const;

type PaxNotifierDrawerAction =
    | { type: typeof PaxNotifierDrawerActionTypes.OPEN_DRAWER }
    | { type: typeof PaxNotifierDrawerActionTypes.CLOSE_DRAWER };

export const DEFAULT_STATE = {
    isOpen: false,
};

export type PaxNotifierDrawerState = typeof DEFAULT_STATE;

export const PaxNotifierDrawerReducer: React.Reducer<PaxNotifierDrawerState, PaxNotifierDrawerAction> =
    produce((draft, action) => {
        switch (action.type) {
            case PaxNotifierDrawerActionTypes.OPEN_DRAWER:
                draft.isOpen = true;
                break;
            case PaxNotifierDrawerActionTypes.CLOSE_DRAWER:
                draft.isOpen = false;
                break;
        }
    });